import React, {useContext} from 'react';
import {Size, TextInput} from "@dts-soldel/dts-react-common";
import MobXContext from "../../../app/mobx/MobXContext";
import {observer} from "mobx-react";
import HelpIcon from "../HelpIcon/HelpIcon";
import HelpText from "../HelpIcon/HelpText";

const propTypes = {};
const defaultProps = {};

const HeaderTitleURLInput = () => {
	const {configuratorStore} = useContext(MobXContext);
	
	return (
		<div className="configurator__inputs__input">
			<TextInput
				size={Size.FULL_WIDTH}
				field="headerTitleURL"
				label="Header Title URL"
				value={configuratorStore.headerTitleURL}
				onChange={configuratorStore.setFieldValue}
				children={
					<HelpIcon
						popOverText={HelpText.headerTitleUrl}
						onUseExampleField="headerTitleURL"
						onUseExampleFieldValue={configuratorStore.setFieldValue}
					/>
				}
			/>
		</div>
	);
};

HeaderTitleURLInput.propTypes = propTypes;
HeaderTitleURLInput.defaultProps = defaultProps;

export default observer(HeaderTitleURLInput);
